import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const uploadStyles = makeStyles(({ palette, colors }: Theme) => createStyles({
  dropzone: {
    minHeight: 250,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    border: `2px dashed ${colors.border}`,
    '&:hover': {
      borderColor: palette.primary.main,
      color: palette.primary.main,
    },
    maxWidth: 300,
    maxHeight: 300,
    margin: 'auto',
  },
  dropzoneActive: {
    borderColor: palette.primary.main,
    color: palette.primary.main,
  },
  input: {
    display: 'none',
  },
  inputLabel: {
    // display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    cursor: 'pointer',
    fontSize: 16,
  },
  preview: {

  },
  previewContainer: {
    border: `1px solid ${colors.border}`,
  },
  previewImage: {
    height: 150,
    maxWidth: '100%',
  },
  uploadButton: {
    background: palette.primary.main,
    borderRadius: 3,
    color: '#FFF',
    width: 140,
    height: 40,
    padding: 5,
    margin: 'auto',
    '&:hover': {
      background: '#c86c00',
    },
  },
  closeButton: {
    background: palette.icons.default,
    color: '#FFF',
    fontWeight: 'bold',
    textTransform: 'unset',
    '&:hover': {
      background: palette.icons.default,
    },
  },
  progress: {
    borderRadius: 4,
    color: palette.progress.backgroundValue,
    background: palette.progress.background,
    '&::-webkit-progress-bar': {
      background: palette.progress.background,
    },
    '&::-webkit-progress-value': {
      background: palette.progress.backgroundValue,
    },
    '&::-moz-progress-bar': {
      background: palette.progress.background,
    },
  },
  title: {
    color: '#26325F',
    fontFamily: 'Montserrat',
    fontSize: 24,
  },
  actionContainer: {
    borderTop: `1px solid ${colors.border}`,
  },
}), { name: 'UploadMedia' });
